import { Checkbox } from 'primereact/checkbox';
import { classNames } from 'primereact/utils';

import '../layout/sass/_form.scss';

export const FormSementesEMudas = ({ values, setFieldValue, setFieldTouched, errors, touched }) => {

    const isFormFieldValid = (name) => {
        const isValid = !!(touched?.[name] && errors?.[name]);
        return isValid;
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFieldValue(`sementesEMudas.${name}`, checked);
        setFieldTouched(`sementesEMudas.${name}`, true);

        if (name !== 'naoNecessarias' && checked) {
            setFieldValue("sementesEMudas.naoNecessarias", false);
        }

        if (name === 'naoNecessarias' && checked) {
            setFieldValue("sementesEMudas.proprias", false);
            setFieldValue("sementesEMudas.terceiros", false);
            setFieldValue("sementesEMudas.viveiroComTermico", false);
            setFieldValue("sementesEMudas.viveiroSemTermico", false);
        }
    };

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <div className="p-col-12">
                <div className="p-formgrid p-grid p-fluid p-mx-0">
                    <div className="p-field p-col-12">
                        <label><strong>Operações Realizadas:</strong></label>
                        <div className="p-d-flex p-flex-wrap p-ai-center p-jc-start">
                            <div className="p-field p-d-flex p-ai-center p-mr-3 p-mb-3 p-col">
                                <label htmlFor="naoNecessarias" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('naoNecessarias') })}>
                                    Não são necessárias
                                </label>
                                <Checkbox
                                    id="naoNecessarias"
                                    name="naoNecessarias"
                                    checked={values.naoNecessarias}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center p-mr-3 p-mb-3 p-col">
                                <label htmlFor="proprias" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('proprias') })}>Próprias</label>
                                <Checkbox
                                    id="proprias"
                                    name="proprias"
                                    checked={values.proprias}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center p-mr-3 p-mb-3 p-col">
                                <label htmlFor="terceiros" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('terceiros') })}>Terceiros</label>
                                <Checkbox
                                    id="terceiros"
                                    name="terceiros"
                                    checked={values.terceiros}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center p-mr-3 p-mb-3 p-col">
                                <label htmlFor="viveiroComTermico" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('viveiroComTermico') })}>Viveiro com tratamento térmico</label>
                                <Checkbox
                                    id="viveiroComTermico"
                                    name="viveiroComTermico"
                                    checked={values.viveiroComTermico}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center p-mr-3 p-mb-3 p-col">
                                <label htmlFor="viveiroSemTermico" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('viveiroSemTermico') })}>Viveiro sem tratamento térmico</label>
                                <Checkbox
                                    id="viveiroSemTermico"
                                    name="viveiroSemTermico"
                                    checked={values.viveiroSemTermico}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                        </div>
                        {!values.naoNecessarias && !values.proprias && !values.terceiros && !values.viveiroComTermico && !values.viveiroSemTermico && (
                            <div className="p-error">Pelo menos uma opção deve ser selecionada.</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}